module.exports = __webpack_public_path__ + "static/media/marina-tepedino.9b7b912d.png";